import "./Description.css";
import Gallery from '../gallery/Gallery'

const Description = () => {
    return (
        <div id="description">
            <div className="descriptionItems">
                <h1>NOS PLATS</h1>
                <div className="content">
                    {/* <p>Nos plats</p> */}
                    <Gallery />
                </div>
            </div>
        </div>
    );
};

export default Description;